import { createFileRoute } from '@tanstack/react-router'
import { ProductGate } from '@bloo-team/core-shell'
import { IntegrationsGovernancePage } from '@bloo-team/product-synthai'

/** Composer shim (S5.0): Settings · Integrations · Governance — @bloo-team/product-synthai, behind the SynthAI gate (its backend serves it). */
function GovernanceRoute() {
  const { clusterId, scopeId } = Route.useParams()
  return (
    <ProductGate product="synthai" clusterId={clusterId} scopeId={scopeId}>
      <IntegrationsGovernancePage clusterId={clusterId} scopeId={scopeId} />
    </ProductGate>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/integrations/governance')({
  component: GovernanceRoute,
})
